<app-header-cartographie screenTitle="Scénarisation" />

<app-breadcrumb-scenarisation>
  <hlm-tabs class="w-full" [tab]="activeTab">
    <hlm-tabs-list>
      @for (link of links; track link.href) {
        <a class="h-12" [hlmTabsTrigger]="link.href" [routerLink]="link.href">{{ link.label }}</a>
      }
    </hlm-tabs-list>
  </hlm-tabs>
</app-breadcrumb-scenarisation>

<div class="bg-background py-lg gap-md h-[calc(100%-175px)] w-full px-11">
  <router-outlet />
</div>
